import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { createLink } from '@meshconnect/web-link-sdk'

const App: React.FunctionComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const linkToken = searchParams.get('linkToken')

    if (linkToken) {
      searchParams.delete('linkToken')
      setSearchParams(searchParams, { replace: true })

      const connection = createLink({
        onIntegrationConnected: _payload => {},
        onEvent: ev => {
          console.debug('[MESH LINK event]', ev)
        }
      })
      connection.openLink(linkToken)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="w-full h-full flex justify-center items-center container m-auto p-4" />
  )
}

export default App
